<template>
    <div class="wrapper">
        <div class="home">
            <div class="header">
                <img class="logo" src="../../assets/app/logo.png" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home'
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .home {
        width: 100%;
    }

    .header {
        width: 100%;
        background: var(--Gray-00, #FFF);
        height: 49px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .logo {
        width: 95.25px;
    }

    @media (min-width: 430px) {
        .home {
            width: 430px;
        }

    }
</style>


// WEBPACK FOOTER //
// src/pages/holiday/Home.vue